import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 120000,
});

export const analyzeChannel = (url, force_refresh = false) =>
  api.post("/analyze", { url, force_refresh }).then((r) => r.data);

export const getDiagnosis = (channelId) =>
  api.get(`/analyze/${channelId}/diagnosis`).then((r) => r.data);

export const searchChannels = (q) =>
  api.get("/search/channels", { params: { q } }).then((r) => r.data);

export const compareChannels = (url_a, url_b) =>
  api.post("/compare", { url_a, url_b }).then((r) => r.data);

export const getHistory = () => api.get("/history").then((r) => r.data);

export const getRankings = (sort = "subscribers") =>
  api.get(`/rankings?sort=${sort}`).then((r) => r.data);

export const getFavorites = () => api.get("/favorites").then((r) => r.data);

export const addFavorite = (payload) =>
  api.post("/favorites", payload).then((r) => r.data);

export const removeFavorite = (channelId) =>
  api.delete(`/favorites/${channelId}`).then((r) => r.data);

export const submitContact = (payload) =>
  api.post("/contact", payload).then((r) => r.data);

export const getHealth = () => api.get("/health").then((r) => r.data);
